import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SubmissionsService } from 'src/app/service/submissions.service';
import { Event } from 'src/app/model/event';
import { AdminService } from 'src/app/service/admin.service';
import { StatisticsService, AuthorCountries } from 'src/app/service/statistics.service';
import { SelectOption } from 'src/app/model/select.option';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ExportService } from 'src/app/service/export.service';

@Component({
  selector: 'app-submission-tracks-statistics',
  templateUrl: './submission-tracks-statistics.component.html',
  styleUrls: ['./submission-tracks-statistics.component.scss']
})
export class SubmissionTracksStatisticsComponent implements OnInit {
  @Input() event: Event;

  form: FormGroup;
  tracks: Array<SelectOption>;
  options: any;
  trackStatus : Array<any>;
  dsTrackStatus : Array<any>;
  tableColsStatus = ['track', 'pending', 'active', 'withdrawn', 'accepted', 'rejected', 'count']
  showSubEventsTracks :boolean = false;

  constructor(
    private statisticsService: StatisticsService,
    protected adminService: AdminService,
    public fb: FormBuilder,
    private exportService: ExportService
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.adminService.progressBar.start();
      if (!this.event) {
        this.adminService.getEvent().subscribe(event => {
          this.event = event;
        }, () => {},
        () => {
          this.initComponent();
          this.getTrackBySubmissionStatus(true);
        });
      } else {
        this.initComponent();
        this.getTrackBySubmissionStatus(true);
      }
    });
  }

  initComponent(){
    this.form = this.fb.group({
      tracks: [],
      submissionGroups: []
    });

    this.tracks = this.event.tracks.map(t => {
      return new SelectOption(t.id, t.name);
    });
  }

  getTrackBySubmissionStatus(init: boolean=false){
    this.statisticsService.getTracksBySubmissionStatus(this.event.id).subscribe( datasource => {
      this.trackStatus = datasource.items;
      // Filter the events to consider only tracks from the current event
      this.dsTrackStatus = this.trackStatus;
      this.statisticsService.setTrackStatus(this.dsTrackStatus.filter(t => t.track !== 'Total')); // Pass data to the shared service
      if(init) this.updateFilters();
      }, () => {
        this.adminService.progressBar.stop();
      },() => {
      this.adminService.progressBar.stop();
    });
  }

  updateFilters() {
    // Use the  (before filtering to)
    this.dsTrackStatus = this.trackStatus;

    if(this.form.value.tracks && this.form.value.tracks.length > 0) {
      this.dsTrackStatus = this.dsTrackStatus.filter(track => this.form.value.tracks.includes(track.id));
    } else {
      this.dsTrackStatus = this.trackStatus.filter(t => t.track !== 'Total');;
    }
    
    if(this.showSubEventsTracks){
      this.handleTracksWithSameName();
    }else{
      // Filter the events to consider only tracks from the current event
      this.dsTrackStatus = this.dsTrackStatus.filter(item => item.event.id==this.event.id);
    }

    this.statisticsService.setTrackStatus(this.dsTrackStatus.filter(t => t.track !== 'Total')); // Pass data to the shared service (without the total row)
    this.setTotalSum();
  }

  // Concatenate a parenthesis to the end of the track name when there are tracks with the same name
  // (This happens when there are tracks from different events - sub-events considered)
  private handleTracksWithSameName(): void{
    const nameCount: Record<string, number> = {};

    // Count occurrences of each track name
    this.dsTrackStatus.forEach(track => {
        nameCount[track.track] = (nameCount[track.track] || 0) + 1;
    });

    // Append the event name to duplicate names
    this.dsTrackStatus = this.dsTrackStatus.map(track => ({
        ...track,
        track: nameCount[track.track] > 1 ? `${track.track} (${track.event.name})` : track.track
    }));
  }

  private setTotalSum(): void{
    const totalIndex = this.dsTrackStatus.findIndex(t => t.track === 'Total');

    const totals = this.dsTrackStatus.reduce((acc, curr) => {
      if (curr.track === 'Total') return acc; // Skip existing total if present
      acc.pending += curr.pending;
      acc.active += curr.active;
      acc.withdrawn += curr.withdrawn;
      acc.accepted += curr.accepted;
      acc.rejected += curr.rejected;
      acc.count += curr.count;
      return acc;
    }, {
      id: -1,
      event: {
        name: '',
        id: -1
      },
      track: 'Total',
      pending: 0,
      active: 0,
      withdrawn: 0,
      accepted: 0,
      rejected: 0,
      count: 0
    });

    if (totalIndex !== -1) {
      // Update the existing total
      this.dsTrackStatus[totalIndex] = totals;
    } else {
      // Add the total entry
      this.dsTrackStatus.push(totals);
    }
  }

  private downloadReport(): void{
    let tracksCSV = this.tableColsStatus.join(';')+'\n';
    tracksCSV += this.dsTrackStatus.map(m => `${m.track};${m.pending};${m.active};${m.withdrawn};${m.accepted};${m.rejected};${m.count}`).join('\n');
    this.exportService.downloadFile(`${this.event.name}-tracks-statistics.csv`, tracksCSV, 'text/csv');
  }
}
